import React from 'react';
import Fuse from 'fuse.js';
import ReactTable, { ReactTableDefaults } from 'react-table';
import { CSVLink } from 'react-csv';
import 'react-table/react-table.css';

import './data-table.css';

export default class DataTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            key: '',
            search: '',
            shouldClick: false,
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.clickInEnter = this.clickInEnter.bind(this);
    }

    componentDidUpdate() {
        if (
            this.props.allData &&
            this.props.allData.length > 0 &&
            this.state.shouldClick
        ) {
            this.csvRef.link.click();
            this.setState({ shouldClick: false });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.loading && this.props.loading && !this.props.manual) {
            this.handleSearch();
        }
    }

    handleSearch = e => {
        e && e.preventDefault();
        this.props.manual
            ? this.tableRef.fireFetchData()
            : this.setState({ key: this.state.search });

        if (this.props.onChangeSearch) {
            this.props.onChangeSearch(this.state.search);
        }
    };

    requestPrepared = state => {
        const order = state.sorted.length > 0 ? state.sorted[0].id : undefined;
        const orderMode =
            state.sorted.length > 0
                ? state.sorted[0].desc
                    ? 'desc'
                    : 'asc'
                : undefined;
        const filter = {
            pageSize: state.pageSize,
            page: state.page,
            order,
            orderMode,
        };
        const { search } = this.state;
        return search ? { ...filter, search } : filter;
    };

    fetchData = state => {
        if (!this.props.manual) {
            return;
        }
        this.props.fetchMethod(this.requestPrepared(state));
    };

    fetchAll = () => {
        if (!this.props.manual) {
            this.csvRef.link.click();
            return;
        }
        this.setState({ shouldClick: true });
        this.props.fetchAllMethod(this.requestPrepared(this.tableRef.state));
    };

    clickInEnter(e) {
        if (e.key === 'Enter') {
            this.handleSearch(e);
        }
    }

    render() {
        const {
            data,
            searchable,
            exportable,
            extra,
            loadComponent,
            ...props
        } = this.props;
        return (
            <div className="data-table">
                <div className="data-table-actions">
                    <div className="extra">{extra && extra()}</div>
                    {exportable !== false && (
                        <div className="data-table-export show">
                            <button
                                title="Exportar CSV"
                                onClick={this.fetchAll}
                            >
                                <i className="fa fa-download" />
                            </button>
                            <CSVLink
                                ref={csvRef => (this.csvRef = csvRef)}
                                data={this.exportableData(
                                    this.props.manual
                                        ? this.props.allData
                                        : this.props.data,
                                )}
                                headers={this.exportableHeaders()}
                                filename={this.props.exportName}
                                target="_self"
                                separator={';'}
                            />
                        </div>
                    )}
                    {searchable !== false && (
                        <div className="data-table-search show">
                            <div
                                onClick={this.handleSearch}
                                title="Buscar"
                                className="icon-wrapper"
                            >
                                <i className="fa fa-search" />
                            </div>
                            <input
                                placeholder="Buscar"
                                value={this.state.search}
                                onChange={({ target }) =>
                                    this.setState({ search: target.value })
                                }
                                onKeyPress={this.clickInEnter}
                            />
                            <button onClick={this.handleSearch}>OK</button>
                        </div>
                    )}
                </div>
                <ReactTable
                    LoadingComponent={loadComponent}
                    ref={tableRef => (this.tableRef = tableRef)}
                    defaultFilterMethod={(filter, row) =>
                        String((row[filter.id] || '').toLowerCase()).includes(
                            (filter.value || '').toLowerCase(),
                        )
                    }
                    onFetchData={this.fetchData}
                    {...props}
                    data={this.props.manual ? data : this.filteredData(data)}
                />
            </div>
        );
    }

    filteredData = data => {
        const { key } = this.state;
        const keys = this.props.columns
            .filter(c => c.searchable)
            .map(m => m.accessor);
        if (!key.trim() || keys.length === 0) {
            return data;
        }
        return new Fuse(data, {
            threshold: 0.0,
            minMatchCharLength: 0,
            keys,
        }).search(key);
    };

    exportableHeaders = () =>
        this.props.columns
            .filter(c => c.exportable !== false)
            .map(item => item.Header, []);

    exportableData = data => {
        const exportableInfos = this.props.columns
            .filter(c => c.exportable !== false)
            .map(item => item.accessor);

        return data.map(d => exportableInfos.map(item => d[item]));
    };
}

Object.assign(ReactTableDefaults, {
    // General
    resizable: true,
    // Text
    previousText: 'Anterior',
    nextText: 'Próximo',
    loadingText: 'Dados sendo carregados. Isso pode levar até 5 minutos...',
    noDataText: 'Nenhum item encontrado',
    pageText: 'Página',
    ofText: 'de',
    rowsText: 'linhas',
});



// WEBPACK FOOTER //
// ./src/components/data-table/data-table.js